const getInitialState = () => {
  return {
    value: {
      timestamp: 0,
    },
    lithology: {
      timestamp: 0,
    },
  }
}

export const reducer = (state = getInitialState(), message) => {
  // test for initialState calls
  if (!message) {
    return state
  }

  if (message.baseline && message.type !== "event") {
    return state
  }

  switch (message.type) {
    case "start":
      return getInitialState()

    case "event":
      return {
        value: message.layer === 0 ? message.events[0] : state.value,
        lithology: message.layer === 1 ? message.events : state.lithology,
      }
    default:
      return state
  }
}
